import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APIHandlerService } from 'src/@services/apihandler.service';
import { CommonService } from 'src/@services/common.service';
import { InnerPagesService } from '../inner-pages.service';
import { CommonPagesService } from 'src/@shared/common-pages.service';
import { AuthServiceService } from 'src/app/auth-service.service';
import { ResponseStatus } from 'src/@shared/enum';
import { getBearerToken } from 'src/@shared/storage/app-storage';
declare var jQuery: any;
@Component({
  selector: 'app-common-layout',
  templateUrl: './common-layout.component.html',
  styleUrls: ['./common-layout.component.scss'],

  standalone: false,
})
export class CommonLayoutComponent implements OnInit {
  //#region properties
  isVisibleProfileDrawer = false;
  currentUrl: any;
  userDetails: any;
  canViewOverview: any = false;
  canViewDashboard: any = false;
  canViewReport: any = false;
  canViewUsers: any = false;
  canViewRoles: any = false;
  canViewAccount: any = false;
  canViewAccountTypes: any = false;
  canViewResources: boolean = false;
  canViewRetailPrograms: boolean = false;
  canViewAgency: any = false;
  settingUrl: any;
  canViewSites: any = false;
  canViewSuppliers: any = false;
  canViewReps: any = false;
  canViewVendors: any = false;
  canViewMaintainance: any = false;
  canViewAnnouncement: any = false;
  canViewliabilities: any = false;
  /** Drives the dimmed backdrop behind the user menu; set from the dropdown's own visible event. */
  isUserMenuOpen = false;
  /** Precomputed for the menu header so the template holds no method call. */
  userInitials = '';
  /** Shown in the header and the menu. Falls back to the email when no name is on record. */
  userFullName = '';
  /** The user's profile picture, or null to fall back to the default icon / initials. */
  userAvatarUrl: string | null = null;
  visible: boolean = false;
  isShowLess: boolean = false;
  canViewEstimates: any;
  canViewBills: any;
  canViewBTs: any;
  pendingNotificationsCount: any = 1;
  canViewBadges: boolean = false;
  canViewUnderReviews: boolean = false;
  canViewTerms: boolean = false;
  currentYear: any = new Date().getFullYear();
  landingURL: any;
  canViewCashflow: boolean = false;
  canViewProjections: boolean = false;
  bearerToken = getBearerToken();
  //#endregion

  //#region functions
  Logout() {
    this.pendingRequestsService.clearPendingRequests();
    // Sign out locally whether or not the API call succeeds; a failed revoke must never keep the user signed in.
    this._iS.logOut().subscribe({
      next: () => this._cS.logOut(),
      error: () => this._cS.logOut(),
    });
  }
  //#endregion
  constructor(
    public _iS: InnerPagesService,
    public _cS: CommonService,
    private _router: Router,
    private route: ActivatedRoute,
    private pendingRequestsService: APIHandlerService,
    private _cpS: CommonPagesService,
    private authService: AuthServiceService
  ) {
    if (sessionStorage.getItem('redirectURL')) {
      const supplier = sessionStorage.getItem('redirectURL')?.split('supplier=')[1] || null;
      if (supplier) {
        _router.navigate(['/brooklyn/users'], { queryParams: { supplier } });
      }
      sessionStorage.removeItem('redirectURL');
    }

    if (this.bearerToken != null) return;

    this.route.queryParams.subscribe((params) => {
      const email = params['e'];
      const rToken = params['t'];
      const paybevToken = params['pt'];
      if (paybevToken) {
        localStorage.setItem('PaybevBearerToken', paybevToken);
      }
      if (!email || !rToken) return;

      const token = (rToken || '').replace('=', '');
      const emailVal = (email || '').replace('=', '');
      console.log('token:', token, 'emailVal:', emailVal);
      localStorage.setItem('BearerToken',token);
      
      this._cpS.validateSsoToken(token, emailVal).subscribe(
        (response: any) => {
          if (response.responseStatus !== ResponseStatus.success) {
            this._cS.displayMessage('error', response.message || 'SSO validation failed');
            this._router.navigate(['/login']);
            return;
          }
          const res = response.result;
          const usersDetails = res.userdetails;
          const userInfo = {
            firstName: usersDetails.firstName,
            lastName: usersDetails.lastName,
            userId: usersDetails.id,
            phoneNumber: usersDetails.phoneNumber,
            agency: usersDetails.agency,
            twoFactorEnabled: usersDetails.twoFactorEnabled,
            isForcePasswordChange: usersDetails.isForcePasswordChange,
            email: usersDetails.email,
          };
          localStorage.setItem('BearerToken', token);
          localStorage.setItem('RefreshToken', res.refreshToken);
          localStorage.setItem('UserRole', res.userRoleDetails.name);
          localStorage.setItem('UserInfo', JSON.stringify(userInfo));
          const brooklynPermissions = (res.userRoleDetails.permissions || []).filter(
            (x: any) => x.moduleType === 'Brooklyn'
          );
          localStorage.setItem('RolePermissions', JSON.stringify(brooklynPermissions));
          localStorage.setItem('IsSiteSelected', JSON.stringify(false));
          if (usersDetails.profileImg != null) {
            localStorage.setItem('profile', JSON.stringify(usersDetails.profileImg));
          } else {
            // Clearing it matters: a picture removed earlier would otherwise come back as a dead URL.
            localStorage.removeItem('profile');
          }
          this.authService.scheduleAutoLogout();
          this._cS.calcUserIdleTime.next('call');
          this.userDetails = userInfo;
          this.setUserInitials();
          this.checkPermissions();
          const path = this._router.url.split('?')[0];
          const rest = { ...this.route.snapshot.queryParams };
          delete rest['t'];
          delete rest['e'];
          this._router.navigate([path], { queryParams: rest });
          this._cS.fetchDataAfterAutoLogin.next(true);
        },
        () => {
          this._router.navigate(['/login']);
        }
      );
    });
  }
  checkPermissions() {
     //check logged in user permissions
    if (this.userDetails) {
      this.canViewOverview = this._iS.canviewOverview();
      this.canViewDashboard = this._iS.canViewDashboard();
      this.canViewReport = this._iS.canViewReports();
      this.canViewUsers = this._iS.canAccessUsers().canViewUsers;
      this.canViewRoles = this._iS.canAccessRoles().canViewRole;
      this.canViewAgency = this._iS.canAccessAgencys().canViewAgency;

      this.canViewAccount = this._iS.canAccessAccounts().canViewAccounts;
      this.canViewAccountTypes =
        this._iS.canAccessAccountTypes().canViewAccounts;

      this.canViewSites = this._iS.canAccessSites().canViewSites;

      this.canViewSuppliers = this._iS.canAccessSuppliers().canViewSuppliers;
      this.canViewReps = this._iS.canAccessReps().canViewReps;
      this.canViewVendors = this._iS.canAccessVendors().canViewVendors;
      this.canViewMaintainance = this._iS.canAccessMaintainance().canViewUsers;
      this.canViewBadges = this._iS.canAccessBadges().canViewBadge;
      this.canViewResources = this._iS.canAccessResources().canViewResources;
      this.canViewRetailPrograms =
        this._iS.canAccessRetailPrograms().canViewRetailPrograms;
      this.canViewUnderReviews =
        this._iS.canAccessUnderReview().canViewUnderReview;
      this.canViewAnnouncement =
        this._iS.canAccessAnnouncement().canViewAnnouncements;
      this.canViewTerms = this._iS.canAccessTerms().canViewTerms;
      this.canViewliabilities = this._iS.canAccessGeneral().canViewGeneral;
      this.canViewEstimates = this._iS.canAccessInvestments().canViewInvestment;
      this.canViewBills = this._iS.canAccessBills().canViewExpenses;
      this.canViewBTs = this._iS.canAccessTransfers().canViewTransfers;
      this.canViewCashflow = this._iS.canviewCashflow();
      this.canViewProjections = this._iS.canViewProjections();
    }
    let allowedPages = [
      { permission: this.canViewUsers, url: '/brooklyn/users' },
      { permission: this.canViewRoles, url: '/brooklyn/roles' },
      { permission: this.canViewAgency, url: '/brooklyn/agency' },
      { permission: this.canViewAccount, url: '/brooklyn/accounts' },
      { permission: this.canViewSites, url: '/brooklyn/sites' },
      { permission: this.canViewSuppliers, url: '/brooklyn/suppliers' },
      { permission: this.canViewReps, url: '/brooklyn/reps' },
      { permission: this.canViewVendors, url: '/brooklyn/vendors' },
      {
        permission: this.canViewRetailPrograms,
        url: '/brooklyn/programs',
      },
      { permission: this.canViewBadges, url: '/brooklyn/badges' },
      { permission: this.canViewTerms, url: '/brooklyn/terms' },
      { permission: this.canViewMaintainance, url: '/brooklyn/maintenance' },
      { permission: this.canViewAnnouncement, url: '/brooklyn/announcements' },
      { permission: this.canViewliabilities, url: '/brooklyn/general' },
    ];

    allowedPages.every((element: any) => {
      if (element.permission) {
        this.settingUrl = element.url;
        return false;
      }
      return true;
    });

    let mainmenus = [
      { permission: this.canViewOverview, url: '/brooklyn/overview' },
      { permission: this.canViewDashboard, url: '/brooklyn/dashboard' },
      { permission: this.canViewEstimates, url: '/brooklyn/investments' },
      { permission: this.canViewBills, url: '/brooklyn/expenses' },
      { permission: this.canViewBTs, url: '/brooklyn/transfers' },
      { permission: this.canViewProjections, url: '/brooklyn/projections' },
      { permission: this.canViewReport, url: '/brooklyn/reports' },
      { permission: this.canViewCashflow, url: '/brooklyn/cashflow' },
    ];

    var allpages = allowedPages.concat(mainmenus);
    allpages.every((element: any) => {
      if (element.permission) {
        this.landingURL = element.url;
        return false;
      }
      return true;
    });
  }

  ngOnInit(): void {
    const token = this._cS.getTokenObj();
    const qp = this.route.snapshot.queryParams;
    const isSsoRequest = qp['t'] && qp['e'];
    if (token == null && !isSsoRequest) {
      this._router.navigate(['/login']);
    }
    this.currentUrl = this._router.url;
    this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
    this.userDetails = localStorage.getItem('UserInfo');
    this.userDetails = JSON.parse(this.userDetails);
    this.setUserInitials();
    this.watchProfilePicture();

    this.checkPermissions();
  }
  /** Seeds from the cache the profile drawer writes, then follows it for the rest of the session. */
  private watchProfilePicture(): void {
    const cached = this.readCachedProfilePicture();
    if (cached && this._cS.profilePicture.value === null) {
      this._cS.profilePicture.next(cached);
    }
    this._cS.profilePicture.subscribe((url: string | null) => (this.userAvatarUrl = url));
  }

  /** The stored picture no longer loads (the blob is gone), so drop it and show the initials. */
  onAvatarLoadFailed(): void {
    localStorage.removeItem('profile');
    this._cS.profilePicture.next(null);
  }

  private readCachedProfilePicture(): string | null {
    const raw = localStorage.getItem('profile');
    if (!raw) {
      return null;
    }
    try {
      const parsed = JSON.parse(raw);
      return typeof parsed === 'string' && parsed.length > 0 ? parsed : null;
    } catch {
      return null;
    }
  }

  private setUserInitials(): void {
    const first = this.userDetails?.firstName ?? '';
    const last = this.userDetails?.lastName ?? '';
    const email = this.userDetails?.['email'] ?? '';
    // A user invited but not yet activated has no name, and an empty header reads as broken.
    this.userInitials = (`${first.charAt(0)}${last.charAt(0)}`.trim() || email.charAt(0)).toUpperCase();
    this.userFullName = `${first} ${last}`.trim() || email;
  }

  clickMe(): void {
    this.isShowLess = !this.isShowLess;
  }

  change(value: boolean): void {}
  check() {
    this.visible = !this.visible;
  }
  navigateToSecondTab(component: any, tabIndex: any) {
    this._router.navigate(['/brooklyn/' + component], {
      queryParams: { tab: tabIndex ? tabIndex : 2 },
    });
  }
  ngAfterViewInit(): void {
    jQuery('.BurgerMenu').click(function () {
      jQuery('body').toggleClass('active-menu');
    });
  }
  showProfileDrawer() {
    this.isVisibleProfileDrawer = true;
    document.body.classList.remove('overflow-auto');
    document.body.classList.add('overflow-none');
  }
  hideProfileDrawer(event: any) {
    this.isVisibleProfileDrawer = event;
    document.body.classList.remove('overflow-none');
    document.body.classList.add('overflow-auto');
  }
}
